import { extendTailwindMerge } from 'tailwind-merge';

export const twMerge = extendTailwindMerge({});

export { twJoin } from 'tailwind-merge';
